import { render, staticRenderFns } from "./urgentVue.vue?vue&type=template&id=ca2e7700&scoped=true&"
import script from "./urgentVue.vue?vue&type=script&lang=js&"
export * from "./urgentVue.vue?vue&type=script&lang=js&"
import style0 from "./urgentVue.vue?vue&type=style&index=0&id=ca2e7700&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2e7700",
  null
  
)

export default component.exports